import { booleanAttribute, ChangeDetectionStrategy, Component, computed, input, Signal } from '@angular/core';
import { SiAvatarComponent } from '@siemens/element-ng/avatar';
import { SiTooltipDirective } from '@siemens/element-ng/tooltip';
import { AuthUser } from '@tran-monorepo/interfaces';

@Component({
    selector: 'tran-user-avatar',
    imports: [SiAvatarComponent, SiTooltipDirective],
    templateUrl: './user-avatar.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserAvatarComponent {
    public readonly userDetails = input.required<AuthUser>();
    public readonly showOnlyAvatar = input(false, { transform: booleanAttribute });

    protected userName: Signal<string> = computed(() =>
        `${this.userDetails()?.given_name || ''} ${this.userDetails()?.family_name || ''}`.trim()
    );
    protected userMail: Signal<string> = computed(() => this.userDetails()?.mail || '');
    protected userOrgCode: Signal<string> = computed(() => this.userDetails()?.org_code || '');
    protected userInitials: Signal<string> = computed(() => {
        const givenName = this.userDetails()?.given_name || '';
        const familyName = this.userDetails()?.family_name || '';
        const initials = (givenName.charAt(0) || '') + (familyName.charAt(0) || '');
        return initials.toUpperCase();
    });
}
